import type { ComponentProps } from 'react';
import {
  Navigate as RRDNavigate,
  generatePath,
  useParams,
  useSearchParams,
} from 'react-router-dom';

type NavigateProps = ComponentProps<typeof RRDNavigate> & {
  keepParams?: boolean;
  keepSearchParams?: boolean;
};

const concatPath = (to: string, searchParams: string) => {
  const containsSearchParams = to.includes('?');
  if (!searchParams) {
    return to;
  }
  return `${to}${containsSearchParams ? '&' : '?'}${searchParams}`;
};

export const Navigate = ({
  keepParams,
  keepSearchParams,
  to,
  ...otherProps
}: NavigateProps) => {
  const [searchParams] = useSearchParams();
  const params = useParams();

  const getTo = () => {
    if (typeof to !== 'string') {
      return to;
    }
    const toWithParams = keepParams ? generatePath(to, params) : to;

    const toWithSearchParams = keepSearchParams
      ? concatPath(toWithParams, searchParams.toString())
      : toWithParams;
    return toWithSearchParams;
  };

  return <RRDNavigate {...otherProps} to={getTo()} />;
};
